import axios from "../../utilities/axios";
import { Event } from "../Event";

export class InfringementControlFkErrorIdEvents extends Event {
    public onChange = async (value: any, setField: any, setState: any, formValues: any) => {
        this.setState("loadings", ["infringement_control_fk_error_id", "infringement_control_value", "infringement_control_fk_group_error_id"])

        if (value) {
            const response = await axios.get("/api/v1/infringement_controls/get_error_details", {
                params: {
                    errorId: value
                }
            })

            console.log("onChange error response :::>> ", response)

            const { use_value_input: useValueInput, group_error_id: groupErrorId } = response.data;

            if (useValueInput) {
                this.setField("infringement_control_fk_error_id", {
                    width: 5
                })

                this.setField("infringement_control_value", {
                    hidden: false,
                    required: true
                })
            } else {
                this.setField("infringement_control_fk_error_id", {
                    width: 7
                })

                this.setField("infringement_control_value", {
                    hidden: true,
                    required: false
                })

                this.setFieldValue("infringement_control_value", 0)
            }

            if (groupErrorId) {
                this.setFieldValue("infringement_control_fk_group_error_id", groupErrorId)
            } else {
                this.setFieldValue("infringement_control_fk_group_error_id", undefined)
            }
        } else {
            this.setField("infringement_control_fk_error_id", {
                width: 7
            })

            this.setField("infringement_control_value", {
                hidden: true,
                required: false
            })

            this.setFieldValue("infringement_control_value", 0)

            this.setFieldValue("infringement_control_fk_group_error_id", undefined)
        }

        setTimeout(() => {
            this.setState("loadings", [])
        }, 100)
    }
}